import './App.css';
import AnimatedRoutes from './components/animatedroutes';


function App() {

  return (
    <div className="App">
      <AnimatedRoutes/>
    </div>
  );
}

export default App;
